export default {
  getWhatsAppApp: (state) => state.app,
  getWhatsAppApps: (state) => state.apps,
  getWhatsAppAppsMap: (state) =>
    state.apps?.reduce((prev, next) => {
      const { id } = next;
      prev[id] = next;
      return prev;
    }, {}),
  getWhatsAppPhoneNumbers: (state) => state.phoneNumbers,
  getWhatsAppMessageTemplate: (state) => state.messageTemplate,
  getWhatsAppMessageTemplates: (state) => state.messageTemplates,
  getWhatsAppMessageTemplatesMap: (state) =>
    state.messageTemplates?.reduce((prev, next) => {
      const { id } = next;
      prev[id] = next;
      return prev;
    }, {}),
  getWhatsAppApprovedMessageTemplates: (state) =>
    (state.messageTemplates || []).filter((template) => template.status === "APPROVED"),
  getWhatsAppDefaultMessageTemplates: (state) => state.defaultMessageTemplates,
  getWhatsAppQuickReply: (state) => state.quickReply,
  getWhatsAppQuickReplies: (state) => state.quickReplies,
  getWhatsAppAssistant: (state) => state.assistant,
  getWAAssistantCurrentStep: (state) => state.WAAssistantCurrentStep,
  getCurrentStep: (state) => state.WAAssistantCurrentStep,
  getSchema: (state) => state.schema,
};
